import { createContext } from 'react';
import { gql, useQuery } from '@apollo/client';
import { ArtistLibrary } from 'types';

const GET_SITE_LIBRARY = gql`
  query GET_SITE_LIBRARY {
    siteLibrary(where: { signature: "lnzame" }) {
      id
      signature
      title
      isSpanish
      facebookLink
      tikTokLink
      instagramLink
      spotifyLink
      twitterLink
      youtubeLink
      pandoraLink
      appleMusicLink
      soundcloudLink
      siteCssBodyClass
      mailchimp
      logo {
        id
        url
      }
      bookingEmailOne
      bookingPhoneOne
      bookingNameOne
      miniBio
      analyticsId
      siteLibraryJson
      displayWhatsAppFloat
      youtubePlaylistId
      whatsAppFloatContactNumber
      labelName
      labelLink
      labelLogo {
        id
        url
      }
      customNavCtaText
      customNavCtaLink
      epkLink
      displayBlogNav
      navigation
      hasSplashPage
      logoSecondary {
        id
        url
      }
      bandsInTownEmailWidget
      paypalClientId
      rootColor {
        dark {
          hex
          rgba {
            r
            g
            b
            a
          }
          css
        }
        primary {
          hex
          rgba {
            r
            g
            b
            a
          }
          css
        }
        primaryHover {
          hex
          rgba {
            r
            g
            b
            a
          }
          css
        }
        primaryFade {
          hex
          rgba {
            r
            g
            b
            a
          }
          css
        }
        primaryFadeOpacity {
          hex
          rgba {
            r
            g
            b
            a
          }
          css
        }
        white {
          hex
          rgba {
            r
            g
            b
            a
          }
          css
        }
      }
    }
  }
`;

export const ArtistContext = createContext<ArtistLibrary>({
  title: '',
  isSpanish: false,
  displayWhatsAppFloat: false,
  facebookLink: '',
  tikTokLink: '',
  instagramLink: '',
  spotifyLink: '',
  twitterLink: '',
  youtubeLink: '',
  siteCssBodyClass: '',
  mailchimp: '',
  logo: {
    url: '',
  },
  bookingEmailOne: '',
  bookingPhoneOne: '',
  bookingNameOne: '',
  miniBio: '',
  analyticsId: '',
  pandoraLink: '',
  appleMusicLink: '',
  soundcloudLink: '',
  youtubePlaylistId: '',
  whatsAppFloatContactNumber: '',
  labelName: '',
  labelLink: '',
  labelLogo: {
    url: '',
  },
  customNavCtaText: '',
  customNavCtaLink: '',
  epkLink: '',
  displayBlogNav: true,
  navigation: {},
  siteLibraryJson: {},
  hasSplashPage: false,
  logoSecondary: {
    url: '',
  },
  logoSecondaryLink: '',
  bandsInTownEmailWidget: '',
  paypalClientId: '',
  rootColor: {
    dark: {
      hex: '',
      rgba: {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
      },
      css: '',
    },
    primary: {
      hex: '',
      rgba: {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
      },
      css: '',
    },
    primaryHover: {
      hex: '',
      rgba: {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
      },
      css: '',
    },
    primaryFade: {
      hex: '',
      rgba: {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
      },
      css: '',
    },
    primaryFadeOpacity: {
      hex: '',
      rgba: {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
      },
      css: '',
    },
    white: {
      hex: '',
      rgba: {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
      },
      css: '',
    },
  },
});

export function ArtistProvider({ children }) {
  const { loading, data } = useQuery(GET_SITE_LIBRARY);
  const artist = loading || !data.siteLibrary ? null : data.siteLibrary;

  return (
    <ArtistContext.Provider value={artist}>{children}</ArtistContext.Provider>
  );
}
